const tel = {
    /**
     * 將一個包含電話號碼的字串 轉 一個包含三個元素的陣列
     * 02-12345678-123 -> ["02", "12345678", "123"]
     *
     * @param {String} value
     * @returns {Array}
     */
    set3columnInput(value) {
        // 2022/10/06 規則，分機也用 -
        return value.split('-');
    },
};

export default tel;
